import {
  DestroyRef,
  ElementRef,
  inject,
  ChangeDetectorRef,
  Component,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';

import type { UserIdMap } from '@core/account-data';
import { InfoboxComponent } from '@core/components-infobox-legacy';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import type { Requisition } from '@core/requisitions-types';
import { RequisitionStatus } from '@core/requisitions-types';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

import { RequisitionsDataProviderService } from '../../data/single-requisition/requisitions-data-provider.service';

@Component({
  selector: 'rt-requisitions-rejection-infobox',
  templateUrl: './rejection-infobox.component.html',
  styleUrls: ['./rejection-infobox.component.less'],
  imports: [RouterModule, ButtonComponent, IconComponent, InfoboxComponent, TranslatePipe],
})
export class RejectionInfoboxComponent {
  private readonly data = inject(RequisitionsDataProviderService);
  private readonly i18n = inject(I18nService);
  private readonly cdRef = inject(ChangeDetectorRef);

  private readonly destroyRef = inject(DestroyRef);
  public readonly RequisitionStatus: typeof RequisitionStatus = RequisitionStatus;
  public readonly COLLAPSED_MESSAGE_MAX_HEIGHT = 72; // 3 * @line-height

  public requisition?: Requisition;
  public rejectionAdminName: string;
  public messageCollapsed: boolean = true;
  public hasExpandButton: boolean;

  private users: UserIdMap;

  @ViewChild('rejectMessageText') private rejectMessageText: ElementRef;

  public ngOnInit(): void {
    this.data.data$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({ requisition, users }) => {
        this.requisition = requisition;
        this.users = users;
        if (requisition.rejectionReason) this.setRejectionAdminName();
        this.cdRef.detectChanges();
      });
  }

  public ngAfterViewInit(): void {
    this.hasExpandButton =
      this.rejectMessageText.nativeElement.scrollHeight > this.COLLAPSED_MESSAGE_MAX_HEIGHT;
    this.cdRef.detectChanges();
  }

  public toggleShowMore(): void {
    this.messageCollapsed = !this.messageCollapsed;
    this.cdRef.detectChanges();
  }

  private setRejectionAdminName() {
    let result = '';
    if (this.requisition?.rejectedById && !!this.users[this.requisition.rejectedById]) {
      const { firstName, lastName } = this.users[this.requisition.rejectedById];
      result = `${firstName} ${lastName}`;
    } else {
      result = this.i18n.translate('app.requisitions.flow.deleted_user');
    }
    this.rejectionAdminName = result;
  }
}
